import { render, staticRenderFns } from "./ProvidersManager.vue?vue&type=template&id=e6a85ec8&"
import script from "./ProvidersManager.vue?vue&type=script&lang=ts&"
export * from "./ProvidersManager.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports